"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleGroupUtils = void 0;
class ArticleGroupUtils {
    /**
     * Sorts an array of `SortableArticleGroups`.
     *
     * @param groups The array of `SortableArticleGroups`
     * @returns The sorted array of `SortableArticleGroups`.
     */
    static sortArticleGroups(groups) {
        return groups.sort((g1, g2) => g1.order - g2.order);
    }
    /**
     * Merges all `SortableArticleGroups` and flattens them to one array of `ArticleGroup`.
     *
     * @param groups The array of `SortableArticleGroups`
     * @returns The merged and flattened array of `ArticleGroup`
     */
    static mergeSortableArticleGroups(groups) {
        return groups
            .map((g) => g.articleGroups)
            .reduce((accGroup, curGroup) => accGroup.concat(curGroup))
            .filter((g) => g != null);
    }
    static isArticleGroupWithTotalCount(ag) {
        return !isNaN(ag.totalCountInKette);
    }
    static getArticleTypes(articleGroups) {
        const articleTypes = [];
        articleGroups.forEach((ag) => {
            if (!articleTypes.includes(ag.article.articleType)) {
                articleTypes.push(ag.article.articleType);
            }
        });
        return articleTypes;
    }
}
exports.ArticleGroupUtils = ArticleGroupUtils;
//# sourceMappingURL=ArticleGroupUtils.js.map